import { Suspense, lazy } from 'react';

import LoadingSpinner from '../components/LoadingSpinner';

/**
 * A paygate modal as an ad-card modal: loaded on open, under the `isOpen`/`onClose` names
 * the cards pass.
 *
 * Lazy for the same reason PremiumOfferProvider's copies are: these modals import
 * services/Mixpanel, which builds a Clerk client at module scope, and useAdModal sits in the
 * import graph of every ad card — a static import would drag Clerk into all of them.
 *
 * `onTrack` is dropped: these modals fire their own events, stamped with the `location` the
 * descriptor names.
 */
export const lazyAdModal = (load) => {
  const Modal = lazy(load);
  return function LazyAdModal({ isOpen, onClose, onTrack: _onTrack, ...props }) {
    if (!isOpen) return null;
    return (
      <Suspense
        fallback={
          // Fetched on the click that opens it; an empty fallback would read as a dead button.
          <div className='fixed inset-0 z-[60] flex items-center justify-center bg-gray-500 bg-opacity-75'>
            <LoadingSpinner />
          </div>
        }>
        <Modal showModal setShowModal={onClose} {...props} />
      </Suspense>
    );
  };
};
